import React, { Component } from 'react'

export class BgFdr extends Component {
    render() {
        return (
                    <div className="box">
                    <div className="box-body">
                        <div className="box-header">
                            <h3 className="box-title">BG/FDR</h3>
                        </div>
                        <div className="box-body">
                            <form action="partworksdetails/savebankdetails">
                                <div className="col-md-12" >
                                <div className="col-md-6" >
                                    <div className="form-group">
                                        <label>Bank Type</label><br/>
                                        <input type="radio" name="bank_type" value="BG" />&nbsp;&nbsp;BG&nbsp;&nbsp;
                                        <input type="radio" name="bank_type" value="FDR" />&nbsp;&nbsp;FDR&nbsp;&nbsp;
                                        <input type="radio" name="bank_type" value="DD" />&nbsp;&nbsp;DD&nbsp;&nbsp;
                                        <input type="radio" name="bank_type" value="Other" />&nbsp;&nbsp;Other&nbsp;&nbsp;
                                        <input type="radio" name="bank_type" value="NA" />&nbsp;&nbsp;NA									
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div className="form-group">
                                        <label>Office Name</label>
                                        <input className="form-control" />
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div className="form-group">
                                        <label>BG/FDR Code</label>
                                        <input type="text" name="code_gen" className="form-control" />
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div className="form-group">
                                        <label>BG/FDR No</label>
                                        <input type="text" name="bank_gurntee_no" className="form-control" />
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div className="form-group">
                                        <label>Agency/Contractor Name</label>
                                        <input className="form-control" />
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div className="form-group">
                                        <label>Expiry Date</label>
                                        <input type="text" placeholder="DD-MM-YYYY" name="expdate" className="form-control" />
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div className="form-group">
                                        <label>BG/FDR Issue Date</label>
                                        <input type="text" placeholder="DD-MM-YYYY" name="bankissdate" className="form-control" />
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div className="form-group">
                                        <label>Project Name</label>
                                        <input className="form-control" />					
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div className="form-group">
                                        <label>Bank Name</label>
                                        <select name="bank_nm" className="form-control">
                                            <option value="">Select Bank</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div className="form-group">
                                        <label>Bank Branch</label>
                                        <input type="text" name="brnch_name" className="form-control" />
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div className="form-group">
                                        <label>Contract Value</label>
                                        <input className="form-control" />	
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div className="form-group">
                                        <label>Bank Confirmation Date</label>
                                        <input type="text" placeholder="DD-MM-YYYY" name="bankcondate" className="form-control" />
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div className="form-group">
                                        <label>Period of B G(In Month)</label>
                                        <input name="period_bg" className="form-control" />	
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div className="form-group">
                                        <label>BG/FDR Amount(In Rupees)</label>
                                        <input name="guarntee_amount" className="form-control" />	
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div className="form-group">
                                        <label>Description</label>
                                        <textarea cols="20" rows="3" className="form-control" name="description" />
                                    </div>
                                </div>
                                </div>
                                <div className="col-md-12" >
                                <div className="col-md-6" >
                                    <input type="submit" className="btn btn-primary" value="Save" />
                                </div>
                                </div>
                            </form>
                            <h5 className="text-center">List BG/FDR</h5>
                            <div className="col-md-12 table-responsive" >
                                <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Sr.no</th>
                                        <th>Bank Type</th>
                                        <th>Officename</th>
                                        <th>BG/FDR Code</th>
                                        <th>Agency/Contractor Name</th>
                                        <th>BG/FDR Issue Date</th>
                                        <th>Bank Name</th>
                                        <th>Bank Branch</th>
                                        <th>BG/FDR Amount(In Rupees)</th>
                                        <th>BG/FDR No</th>
                                        <th>Expiry Date</th>
                                        <th>Project Name</th>
                                        <th>Contract Value</th>
                                        <th>Bank Confirmation Date</th>
                                        <th>Edit</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>

                                </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    </div>
        )
    }
}

export default BgFdr
